export function createInboxApiUrl (apiState, resource) {
  const protocol = 'https'
  const host = apiState.inboxServerHost

  return `${protocol}://${host}/api${resource}`
}
